<circ-filter-group
  [title]="'filterGroup_stepList_title'"
  [actions]="filterActions"
  [isLoading]="isLoading"
  [selectedFilterId]="selectedFilter$ | async"
  (filterClick)="onFilterClick($event)"
>
</circ-filter-group>
<circ-loader [isLoading]="isLoading">
  <circ-my-tasks-grid
    [gridData]="tasks$ | async"
    [initialSort]="initialSort"
    (cellClick)="onCellClick($event)"
    (sortChange)="onSortChange($event)" >
  </circ-my-tasks-grid>
</circ-loader>
